export default __webpack_public_path__ + "static/media/7-small.9d136aaa.png";